import React from 'react';

export const ConnectionTestLabel: React.FC<{ children?: React.ReactNode }> = ({
  children = 'Probar conexión',
}) => (
  <>
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      width="15"
      height="15"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m9 12 2 2 4-4" />
      <path d="M12 3a9 9 0 1 0 9 9" />
      <path d="M16 3h5v5" />
    </svg>
    <span>{children}</span>
  </>
);
